const list = [
    { id: "read", name: "Read" },
    { id: "unread", name: "Unread" },
  ];
  
  const find = (key) => {
    let ext = list.find((itm) => itm.id == key);
    return ext;
  };
  
  const name = (key) => {
    let ext = list.find((itm) => itm.id == key);
    return ext ? ext.name : key;
  };
  
  const readModel = { list, find, name };
  export default readModel;
  